import { Formik } from "formik";
import { useSelector } from "react-redux";
import { Fragment, useState } from "react";
import { Paper, Stack } from "@mui/material";
import { Button, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, VerifiedUser } from "@mui/icons-material";

import Form from "./Form";
import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import { OuterBox } from "../../components";

const CheckIn = () => {
  const axios = useAxios();
  const navigate = useNavigate();

  const { visitorData } = useSelector((state) => state.memberDetails);

  const localStorageData = { ...localStorage };

  const [closeQR, setQRClose] = useState(false);
  const [hotelData, setHotelData] = useState({ id: "", hotelID: "" });

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return (
      item.includes(visitorData.ID) ||
      (item.includes(visitorData.ID) && item.includes("face&docs"))
    );
  });

  const [formData, setFormData] = useState({
    QRCode: "",
  });

  return (
    <OuterBox>
      {!closeQR ? (
        <Fragment>
          {!digipassDataKey[0] ? (
            <Fragment>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#f1f9ff",
                  borderLeft: "5px solid #1976d2",
                  mt: 2,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <VerifiedUser color="primary" />
                  <Typography variant="body1" fontWeight={500}>
                    Kindly complete your profile verification — Face or Document
                    required.
                  </Typography>
                </Stack>

                <Button
                  variant="contained"
                  size="medium"
                  onClick={() => navigate(pages.Profile.route)}
                  sx={{ textTransform: "capitalize", ml: 2 }}
                >
                  Verify Now
                </Button>
              </Paper>
            </Fragment>
          ) : (
            <Formik
              initialValues={formData}
              onSubmit={(formData, { setSubmitting }) => {
                let localStorageData = localStorage;
                const digipassDataKey = Object.keys(localStorageData).filter(
                  (item) => {
                    return item.includes(visitorData.ID);
                  }
                );
                let docs = {};
                Object.keys(localStorage).forEach((item) => {
                  if (item.includes(visitorData.ID)) {
                    docs = localStorageData.getItem(item);
                  }
                });

                axios({
                  url: "event/verify/compare-face",
                  method: "POST",
                  data: { face_data: formData.ImgData, visitor_data: docs },
                }).then((response) => {
                  if (response.status) {
                    setHotelData({
                      id: formData.bookingID,
                      hotelID: formData?.QRCode,
                    });
                    setQRClose(true);

                    // axios({
                    //   url: "hotel/booking",
                    //   method: "POST",
                    //   data: {
                    //     booking_id: formData.bookingID,
                    //     guests_count: 1,
                    //     checkin_datetime: new Date().getTime() / 1000,
                    //     checkout_datetime:
                    //       (new Date().getTime() + 60 * 60) / 1000,
                    //     hotel_id: formData?.QRCode,
                    //     guest_name:
                    //       visitorData.firstName + visitorData.lastName,
                    //     visitor_data: docs,
                    //   },
                    // }).then((response) => {
                    //   if (response.status) {
                    //   }
                    // });
                  }
                });
              }}
            >
              {(formikProps) => {
                return (
                  <Fragment>
                    <Form formikProps={formikProps} />
                  </Fragment>
                );
              }}
            </Formik>
          )}
        </Fragment>
      ) : (
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              backgroundColor: "#e6f4ea",
              borderLeft: "5px solid #4caf50",
              borderRadius: 2,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <CheckCircle sx={{ color: "#4caf50" }} />
              <Typography variant="body1" fontWeight={600} color="success.main">
                You're checked in! One last step to complete your onboarding.
              </Typography>
            </Stack>

            <Typography variant="body2" mt={3} mb={3}>
              Please provide your consent to continue with the process. This
              helps us ensure a smooth and secure experience.
            </Typography>

            <Button
              variant="contained"
              sx={{
                mt: 2,
                textTransform: "capitalize",
                backgroundColor: "#4caf50",
                "&:hover": { backgroundColor: "#43a047" },
              }}
              onClick={() =>
                navigate(
                  pages.Consent.route +
                    "?entity_id=" +
                    hotelData?.hotelID +
                    "&booking_id=" +
                    hotelData.id +
                    "&visitorId=" +
                    visitorData.ID +
                    "&user_type_id=5"
                )
              }
            >
              Give Consent
            </Button>
          </Paper>
        </Grid>
      )}
    </OuterBox>
  );
};

export default CheckIn;
